/**
 * 注意
 * require.context函数是webpack提供的函数，不是js原生函数，因此，只能发生在构建阶段，全部引入。
 * 缺点就是，无法动态引入，只能全部引入。
 * 但是，现在无多语言需求，所以，这个缺点暂时不用考虑。
 * 如果要考虑，可以使用import()函数，动态引入。需要验证兼容性，以及正则匹配目录等功能。
 */

// 导入目录下所有模块
const zhContext = require.context("./lang/zh", true, /\.ts$/);
const enContext = require.context("./lang/en", true, /\.ts$/);

export function getAllMessages(locale: "zh" | "en") {
  const context = locale === "zh" ? zhContext : enContext;
  // 导出所有模块
  const modules: Record<string, Record<string, string>> = {};
  context.keys().forEach((key: string) => {
    const moduleName = key.replace(/\.\/(.+)\.ts$/, "$1");
    modules[moduleName] = context(key).default;
  });
  return modules;
}
